// extracted by mini-css-extract-plugin
export default {"root":"Pager__root--3TabW","item":"Pager__item--rOc8R","active":"Pager__active--1YvNW"};